import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { PersonInfo } from 'types/electionService';
import { addOrUpdateDependent, getSubscriberById } from 'api/operations/electionService';
import { makeAutoObservable, runInAction } from 'mobx';

export interface DependentMainData {
  id: string;
  fullName: string;
  dateOfBirth: string;
  memberType: string;
}

interface DomainParams {
  dependent: PersonInfo;
  subscriberId: string;
}

export default class SubDependentDelegate {
  private _dependent: PersonInfo;
  private _subscriberId: string;

  public get dependent(): PersonInfo {
    return this._dependent;
  }

  public get mainData(): DependentMainData {
    const { id, firstName, middleName, lastName, dob, type } = this._dependent;
    return {
      id,
      fullName: `${firstName} ${middleName || ''} ${lastName}`,
      dateOfBirth: dob ? dateFormatters.normDateToShortAmericanDate(dob) : '',
      memberType: type,
    };
  }

  public async updateDependent(updatedData: PersonInfo): Promise<void> {
    await addOrUpdateDependent(this._subscriberId, updatedData);
    await runInAction(async () => {
      const subscriber = await getSubscriberById(this._subscriberId);
      runInAction(() => {
        this._dependent =
          subscriber.custom.dependents.find((dependent) => dependent.id === this._dependent.id) ||
          ({ firstName: '', lastName: '' } as PersonInfo);
      });
    });
  }

  constructor({ dependent, subscriberId }: DomainParams) {
    this._dependent = dependent;
    this._subscriberId = subscriberId;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
